/**
 * useLoading.tsx - Loading State Hook
 *
 * Wraps async functions with automatic loading state management and error handling.
 */

import { useState } from "react"
import { errorsReported, ErrorsReportedOptions, EXIT_MARKER } from "./errorsReported"

export const useLoading = <T, P>(f: (v?: P) => Promise<T>, { onFinished = () => null, ...opts }: ErrorsReportedOptions = {}) => {
    const [error, setError] = useState<string>(null)
    const [loading, setLoading] = useState<boolean>()

    const onClick = errorsReported(async (v?: P) => {
        if (loading) {
            return EXIT_MARKER as any as T
        }
        setLoading(true)
        const rt = await f(v)
        return rt
    }, {
        ...opts,
        setError,
        onFinished() {
            setLoading(false)
            onFinished()
        }
    })
    return { onClick, loading, error }
}
